import { Link } from 'react-router-dom'
import { Instagram, Youtube, Facebook } from 'lucide-react'
import { NewsletterSignupWidget } from '@/features/mailing-list'
import { useConsent } from '@/features/consent'

const socialLinks = [
  { href: 'https://www.instagram.com/onedaydance/', label: 'Instagram', Icon: Instagram },
  {
    href: 'https://www.youtube.com/channel/UCNIdQBvGM_Z9Pbe-CNRp5Mw',
    label: 'YouTube',
    Icon: Youtube,
  },
  { href: 'https://www.facebook.com/OneDayDanceGroup/', label: 'Facebook', Icon: Facebook },
]

export function PublicFooter() {
  const { openPreferences } = useConsent()

  return (
    <footer className="relative z-10 border-t bg-background">
      <div className="container mx-auto px-5 py-10 sm:px-6 sm:py-12">
        <div className="grid grid-cols-2 gap-x-8 gap-y-10 md:grid-cols-[1.15fr_0.7fr_0.7fr_1.35fr] md:gap-8">
          {/* Brand */}
          <div className="col-span-2 space-y-3 md:col-span-1">
            <p className="text-sm font-bold uppercase tracking-widest">One Day Dance</p>
            <p className="max-w-xs text-sm text-muted-foreground">
              Dance film, community, and opportunity. NYC-based since 2018.
            </p>
          </div>

          {/* Links */}
          <div className="space-y-3">
            <p className="text-sm font-semibold">Explore</p>
            <nav className="flex flex-col gap-2 text-sm text-muted-foreground">
              <Link to="/seasons" className="transition-colors hover:text-foreground">
                Films
              </Link>
              <Link to="/company" className="transition-colors hover:text-foreground">
                Company
              </Link>
              <Link to="/services" className="transition-colors hover:text-foreground">
                Services
              </Link>
              <Link to="/festivals" className="transition-colors hover:text-foreground">
                Festivals
              </Link>
              <Link to="/festivals/oddfest" className="transition-colors hover:text-foreground">
                ODDFEST
              </Link>
              <Link to="/festivals/shift" className="transition-colors hover:text-foreground">
                S.H.I.F.T.
              </Link>
              <Link to="/applications" className="transition-colors hover:text-foreground">
                Apply
              </Link>
            </nav>
          </div>

          {/* Social */}
          <div className="space-y-3">
            <p className="text-sm font-semibold">Connect</p>
            <div className="flex flex-wrap gap-2">
              {socialLinks.map(({ href, label, Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="inline-flex size-9 items-center justify-center rounded-full border border-border text-muted-foreground transition-colors hover:border-brand-orange/60 hover:bg-brand-orange-light/40 hover:text-foreground"
                >
                  <Icon className="size-4" aria-hidden="true" />
                </a>
              ))}
            </div>
            <a
              href="https://fundraising.fracturedatlas.org/one-day-dance"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              Donate →
            </a>
          </div>

          {/* Newsletter */}
          <div className="col-span-2 space-y-3 md:col-span-1">
            <div>
              <p className="text-sm font-semibold">Stay in the Loop</p>
              <p className="mt-1 text-xs text-muted-foreground">
                New films, events, and opportunities—occasionally.
              </p>
            </div>
            <NewsletterSignupWidget />
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center gap-4 border-t pt-6 text-center text-xs text-muted-foreground sm:flex-row sm:justify-between sm:text-left">
          <p>© {new Date().getFullYear()} One Day Dance. All rights reserved.</p>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 sm:justify-end">
            <Link to="/press-kit" className="transition-colors hover:text-foreground">
              Press Kit
            </Link>
            <Link to="/terms" className="transition-colors hover:text-foreground">
              Terms of Service
            </Link>
            <Link to="/privacy" className="transition-colors hover:text-foreground">
              Privacy Policy
            </Link>
            <button
              type="button"
              className="cursor-pointer transition-colors hover:text-foreground"
              onClick={openPreferences}
            >
              Cookie Settings
            </button>
          </div>
        </div>
      </div>
    </footer>
  )
}
